import React, { useEffect, useState } from "react";
import api from "../api";

const countCards = [
  { key: "affiliateCount", label: "Affiliates" },
  { key: "conversionCount", label: "Conversions" },
  { key: "promoterCount", label: "Promoters" },
  { key: "productCount", label: "Products" },
  { key: "collectionCount", label: "Collections" },
];

export default function Dashboard() {
  const [metrics, setMetrics] = useState(null);
  useEffect(() => { api.get("/dashboard").then((res) => setMetrics(res.data)).catch(() => setMetrics({})); }, []);
  const summary = metrics?.commissionSummary || [];
  return (
    <div data-testid="dashboard-page">
      <header className="page-head"><h1>Dashboard</h1></header>
      <div className="metric-grid">
        {countCards.map((card) => (
          <div className="metric-card" key={card.key} data-testid={`metric-${card.key}`}>
            <div className="metric-label">{card.label}</div>
            <div className="metric-value">{metrics ? metrics[card.key] ?? 0 : "…"}</div>
          </div>
        ))}
      </div>
      <h2 className="section-title">Commission Summary by Currency</h2>
      <div className="table-wrap">
        <table data-testid="commission-summary-table">
          <thead><tr><th>Currency</th><th>Pending</th><th>Payable Gross</th><th>Outstanding Clawback</th><th>Currently Owed</th><th>Paid</th><th>Lifetime</th></tr></thead>
          <tbody>{summary.map((row) => (
            <tr key={row.currency}><td>{row.currency}</td><td>{row.pending}</td><td>{row.payableGross}</td><td>{row.outstandingClawback}</td><td>{row.netCurrentlyOwed}</td><td>{row.paid}</td><td>{row.lifetime}</td></tr>
          ))}</tbody>
        </table>
        {metrics && summary.length === 0 && <div className="empty">No V2 commission activity yet.</div>}
      </div>
    </div>
  );
}
